import * as React from 'react';

export interface ICardFooterProps {
	isHidden?: boolean;
}

export default class CardFooter extends React.Component<ICardFooterProps, {}> {
	public render() {
		if (this.props.isHidden) {
			return null;
		}

		return <div className="card-footer">{this.props.children}</div>;
	}
}
